export { StepIndicator, StepIndicatorProps } from './step-indicator';